
export default {
  data() {
    return {
      selectedModule: 1, // For desktop cards
      expandedModule: null, // For mobile accordion
      modules: [
        {
          id: 1,
          hours: '50 hours',
          title: 'English Language Teaching Methodology Module',
          fullTitle: 'English Language Teaching Methodology Module',
          description: 'Learn about classroom management, teaching styles and advanced TEFL methodology. Study with a personal tutor and meet fellow students on our course forums. Includes units on business English, young learners and teaching English one-to-one.',
          content: [
            'Understanding Teacher and Student Roles',
            'Teaching Methodologies, Strategies and Lesson Planning Structures',
            'Activities in the Classroom',
            'Classroom Management, Correcting Errors and Giving Feedback',
            'Teaching Vocabulary and Functions',
            'Reading and Listening',
            'Writing and Speaking',
            'Introduction to Phonology',
            'Teaching Young Learners',
            'Teaching Business English',
            'Teaching One-to-One',
            'PPP Lesson'
          ]
        },
        {
          id: 2,
          hours: '30 hours',
          title: 'Grammar and Language Awareness Module',
          fullTitle: 'Grammar and Language Awareness Module',
          description: "Don't know your irregular verbs from auxiliary verbs? This course will improve your basic grammar and give you the grounding you'll need to communicate complicated language rules to a student audience.",
          content: [
            'Introduction',
            'Nouns',
            'Verbs',
            'Verbs that are not verbs',
            'Adjectives and adverbs',
            'Other parts of speech',
            'Present, past and future tenses',
            'Conditionals'
          ]
        },
        {
          id: 3,
          hours: '20 hours',
          title: 'Video Observation Module',
          fullTitle: 'Video Observation Module',
          description: "Seeing an English teacher in action is a potent learning tool and really brings the theory to life. Feel free to steal the ideas in these video courses to use in your first lessons. We don't mind!",
          content: [
            'A comparison of two classes',
            'Functional language lesson',
            'A foreign language lesson',
            'Skills based lesson',
            'Dealing with difficult students'
          ]
        },
        {
          id: 4,
          hours: '10 hours',
          title: 'Teaching Online Module',
          fullTitle: '10-hour Teaching Online Module',
          description: 'Develop the skills to teach English online with confidence. This module consists of four units that equip you with practical techniques for planning, delivering, and managing successful online lessons.',
          content: [
            'Foundations of Online English Learning',
            'Lesson Planning for Online Learning',
            'Delivering the Online Lesson',
            'Next Steps: Job Search & Career Tips'
          ]
        },
        {
          id: 5,
          hours: '10 hours',
          title: 'Teaching Large Classes Module',
          fullTitle: 'Teaching Large Classes Module',
          description: 'Learn how to organise and teach effectively when dealing with a large classroom.',
          content: [
            'Introduction to teaching large classes',
            'Organising your classroom',
            'Engaging your students and keeping discipline'
          ]
        }
      ]
    };
  },
  methods: {
    toggleModule(id) {
      // If clicking an already open accordion, just close it
      if (this.expandedModule === id) {
        this.expandedModule = null;
        return;
      }

      // Set the new expanded module
      this.expandedModule = id;

      // Scroll to the accordion item after a brief delay to allow content to render
      this.$nextTick(() => {
        setTimeout(() => {
          const element = this.$refs[`accordion-${id}`];
          if (element && element[0]) {
            const top = element[0].getBoundingClientRect().top + window.scrollY - 100; // adjust 80 to suit
            window.scrollTo({ behavior: 'smooth', top });
          }
        }, 100);
      });
    }
  }
};
